/**
 * ControlConfigFactory - Dynamically loads the appropriate config panel for each control
 *
 * Factory pattern for control configuration panels.
 * Automatically selects between custom panels and generic panel.
 */
import React from 'react';
import ControlConfigPanel from './ControlConfigPanel';
import CTRL_02_ConfigPanel from './CTRL_02_ConfigPanel';
import CTRL_03_ConfigPanel from './CTRL_03_ConfigPanel';
import CTRL_04_ConfigPanel from './CTRL_04_ConfigPanel';
import CTRL_05_ConfigPanel from './CTRL_05_ConfigPanel';
import CTRL_06_ConfigPanel from './CTRL_06_ConfigPanel';
import CTRL_07_ConfigPanel from './CTRL_07_ConfigPanel';
import CTRL_08_ConfigPanel from './CTRL_08_ConfigPanel';
import CTRL_09_ConfigPanel from './CTRL_09_ConfigPanel';
import CTRL_10_ConfigPanel from './CTRL_10_ConfigPanel';
import CTRL_12_ConfigPanel from './CTRL_12_ConfigPanel';
import CTRL_13_ConfigPanel from './CTRL_13_ConfigPanel';
import CTRL_14_ConfigPanel from './CTRL_14_ConfigPanel';
import GenericControlConfigPanel from './GenericControlConfigPanel';

// Registry of custom config panels
const CONFIG_PANELS = {
  'CTRL_01': ControlConfigPanel,
  'CTRL_02': CTRL_02_ConfigPanel,
  'CTRL_03': CTRL_03_ConfigPanel,
  'CTRL_04': CTRL_04_ConfigPanel,
  'CTRL_05': CTRL_05_ConfigPanel,
  'CTRL_06': CTRL_06_ConfigPanel,
  'CTRL_07': CTRL_07_ConfigPanel,
  'CTRL_08': CTRL_08_ConfigPanel,
  'CTRL_09': CTRL_09_ConfigPanel,
  'CTRL_10': CTRL_10_ConfigPanel,
  'CTRL_12': CTRL_12_ConfigPanel,
  'CTRL_13': CTRL_13_ConfigPanel,
  'CTRL_14': CTRL_14_ConfigPanel
};

// Controls that use generic panel (all controls now have custom panels)
const GENERIC_CONTROLS = [];

/**
 * Factory function to get the appropriate config panel component
 *
 * @param {string} controlCode - Control code (e.g., 'AI_01')
 * @returns {React.Component} Config panel component
 */
export function getConfigPanel(controlCode) {
  // Check if custom panel exists
  if (CONFIG_PANELS[controlCode]) {
    return CONFIG_PANELS[controlCode];
  }

  // Fall back to generic panel
  return GenericControlConfigPanel;
}

/**
 * Check if control has a custom config panel
 *
 * @param {string} controlCode - Control code
 * @returns {boolean} True if custom panel exists
 */
export function hasCustomPanel(controlCode) {
  return controlCode in CONFIG_PANELS;
}

/**
 * ControlConfigFactory Component
 *
 * Dynamically renders the appropriate config panel based on control code
 */
function ControlConfigFactory({ controlCode, projectId, project }) {
  const ConfigComponent = getConfigPanel(controlCode);

  if (!ConfigComponent) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#888' }}>
        No configuration panel available for {controlCode}
      </div>
    );
  }

  return (
    <ConfigComponent
      controlCode={controlCode}
      projectId={projectId}
      project={project}
    />
  );
}

export default ControlConfigFactory;
